<template>
<div>
    <div class="popover-title border-0">
        Mark as Delivered
        <i class="close" @click="$emit('openCloseMarkAsDeliveredPopover', false)" >
        <svgicon name="cancelblack-trans" width="12" height="12" />
        </i>
    </div>
    <div class="popover-body">
        <div
          v-for="(destination,index) in destinations"
          :key="index"   
        >
        <MarkasDeliveredRow :destination="destination"
          @changeDate="changeDate"
          :maxGateTruckOutDate="maxGateTruckOutDate"
          :getBackDateConfig="getBackDateConfig"
        /> 
        </div>    
        
    </div>
    <div class="popover-footer">
        <Button type="primary" size="mini" @click="$emit('deliverSubmit', payload)">
            Submit
        </Button>
    </div>
</div>
</template>
<script>
import { uniqBy } from 'lodash';
import MarkasDeliveredRow from './row';
export default {
  props: ['order', 'getBackDateConfig'],

  components: {
      MarkasDeliveredRow,
  },

  computed:{
    destinations() {
      return uniqBy(this.order.destinations, 'location_id');
    },
    maxGateTruckOutDate() {
      const maxGateTruckOut = new Date(
        this.$moment.max(
          this.order.sources.map(_sources => this.$moment(_sources.dispatched_at)),
        ),
      );
      return maxGateTruckOut;
    },
  },
  methods:{
    changeDate(selected) {
      
      const payload = this.payload;
      console.log('inchangeDate ', selected, payload);
      const idx = payload
        .map(e => e.destination_id)
        .indexOf(selected.destination_id);
      if (idx !== -1) {
        payload.splice(idx, 1, selected);
      } else {
        payload.push(selected);
      }
      console.log('inchangeDate1 ', payload);
    },
  },
  data() {
    return {
      payload: [],
    };
  },
}
</script>